import AplicacaoPadrao from "esocial.web.react.lib/cjs/components/AplicacaoPadrao";
import { Route } from 'react-router-dom';
import Home from './pages/Home';
import InfoEmpregadorRegistro from './pages/InfoEmpregador/InfoEmpregadorRegistro';
import GestaoTrabalhadores from './pages/GestaoTrabalhadores/Pesquisa';
import CatListagem from "./pages/Cat/CatListagem";
import CatRegistro from "./pages/Cat/CatRegistro";
import CatConsulta from "./pages/Cat/CatConsulta";
import MonitoramentoSaudeListagem from "./pages/MonitoramentoSaude/MonitoramentoSaudeListagem";
import MonitoramentoSaudeRegistro from "./pages/MonitoramentoSaude/MonitoramentoSaudeRegistro";
import MonitoramentoSaudeConsulta from "./pages/MonitoramentoSaude/MonitoramentoSaudeConsulta";
import ExposicaoRiscoListagem from "./pages/ExposicaoRisco/ExposicaoRiscoListagem";
import ExposicaoRiscoRegistro from "./pages/ExposicaoRisco/ExposicaoRiscoRegistro";
import ExposicaoRiscoConsulta from "./pages/ExposicaoRisco/ExposicaoRiscoConsulta";
import EventosPorReciboListagem from "./pages/EventosPorReciboListagem/EventosPorReciboListagem";

function App() {
    return (
        <AplicacaoPadrao>
            {/*Essa � a �rea reservada para rotas privadas*/}
            {/*Adicionar somente rotas como no exemplo abaixo*/}
            <Route index element={<Home />} />

            {/*Empregador*/}
            <Route path="infoempregador">
                <Route path="consultar"
                    element={<InfoEmpregadorRegistro />} />

                <Route path="eventosPorRecibo"
                    element={<EventosPorReciboListagem />} />
            </Route>
            {/*Fim de Empregador*/}

            <Route path="gestaoTrabalhadores">
                <Route index element={<GestaoTrabalhadores />} />

                <Route path=":idTrabalhador"
                    element={<GestaoTrabalhadores />}/>
            </Route>

            <Route path="gestaoTrabalhadoresTsv">
                <Route index element={<GestaoTrabalhadores tsv />} />

                <Route path=":idTrabalhador"
                    element={<GestaoTrabalhadores tsv />} />
            </Route>

            {/*Cat*/}
            <Route path="cat">
                <Route path="registrar/:idTrabalhador/:idEvento/:idContrato/:tsv/:admPreliminar"
                    element={<CatRegistro />} />

                <Route path=":idTrabalhador/:idContrato/:tsv/:admPreliminar"
                    element={<CatListagem />} />

                <Route path="visualizar/:idTrabalhador/:idEvento/:idContrato/:tsv/:admPreliminar"
                    element={<CatConsulta visualizacao />} />

                <Route path="retificar/:idTrabalhador/:idEvento/:idContrato/:tsv/:admPreliminar"
                    element={<CatRegistro retificacao />} />
            </Route>
            {/*Fim de Cat*/}

            {/*MonitoramentoSaude*/}
            <Route path="monitoramentoSaude">
                <Route path="registrar/:idTrabalhador/:idEvento/:idContrato/:tsv/:admPreliminar"
                    element={<MonitoramentoSaudeRegistro/>} />

                <Route path="visualizar/:idTrabalhador/:idEvento/:idContrato/:tsv/:admPreliminar"
                    element={<MonitoramentoSaudeConsulta visualizacao />} />

                <Route path="retificar/:idTrabalhador/:idEvento/:idContrato/:tsv/:admPreliminar"
                    element={<MonitoramentoSaudeRegistro retificacao />} />

                <Route path=":idTrabalhador/:idContrato/:tsv/:admPreliminar"
                    element={<MonitoramentoSaudeListagem />} />
            </Route>
            {/*Fim de MonitoramentoSaude*/}

            {/*ExposicaoRisco*/}
            <Route path="exposicaoRisco">
                <Route path="registrar/:idTrabalhador/:idEvento/:idContrato/:tsv/:admPreliminar"
                    element={<ExposicaoRiscoRegistro />} />

                <Route path="visualizar/:idTrabalhador/:idEvento/:idContrato/:tsv/:admPreliminar"
                    element={<ExposicaoRiscoConsulta visualizacao />} />

                <Route path="retificar/:idTrabalhador/:idEvento/:idContrato/:tsv/:admPreliminar"
                    element={<ExposicaoRiscoRegistro retificacao />} />

                <Route path=":idTrabalhador/:idContrato/:tsv/:admPreliminar"
                    element={<ExposicaoRiscoListagem />} />
            </Route>
            {/*Fim de ExposicaoRisco*/}
        </AplicacaoPadrao>
    );
}

export default App;
